import { ComponentClass } from 'react';
import { createLazyComponent, LazyAction, LazyModule } from 'owa-bundling';
export { ComponentClass };

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "TimePanel", webpackPrefetch: true */ './lazyIndex')
);

// Delayed Loaded Components
export const TimePanel = createLazyComponent(lazyModule, m => m.TimePanel);
export const TimePanelHeaderBar = createLazyComponent(lazyModule, m => m.TimePanelHeaderBar);

// Delayed Loaded Actions
export const lazyInitializeTimePanel = new LazyAction(lazyModule, m => m.preloadTimePanelData);
export const lazyOpenTimePanel = new LazyAction(lazyModule, m => m.openTimePanel);
export const lazyOpenEventDetailsView = new LazyAction(lazyModule, m => m.openEventDetailsView);
export const lazyOpenConflictsView = new LazyAction(lazyModule, m => m.openConflictsView);
export const lazyCloseConflictsView = new LazyAction(lazyModule, m => m.closeConflictsView);
